import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BadgesSection from './components/BadgesSection';
import ContentSection from './components/ContentSection';
import PessoaFisicaSection from './components/PessoaFisicaSection';
import FrotasSection from './components/FrotasSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App bg-[#0a0f1e] min-h-screen">
      <Header />
      <HeroSection />
      <BadgesSection />
      <ContentSection />
      <PessoaFisicaSection />
      <FrotasSection />
      <AboutSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
